export default __webpack_public_path__ + "static/media/modernJavaScriptFeatures.4c2de981.md";